import { Helpers } from '../../helpers';
import { IScheduleTaskAttribute } from '../../interfaces/ischedule-task-attribute';
import { ScheduleTaskAttributeRateKey } from '../schedule-task-attribute-rate-key';
import { ScheduleTaskAttributeResourceCalculationKey } from '../schedule-task-attribute-resource-calculation-key';

export class ScheduleTaskAttributeBase {
  ScheduleTaskAttributeId: number;
  Name: string;
  Value: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ScheduleTaskAttributeRateKeys_ScheduleTaskAttribute?: Array<ScheduleTaskAttributeRateKey> | null;
  ScheduleTaskAttributeResourceCalculationKeys_ScheduleTaskAttribute?: Array<ScheduleTaskAttributeResourceCalculationKey> | null;

  constructor(item?: IScheduleTaskAttribute) {
    if (item) {

      this.ScheduleTaskAttributeId = item.ScheduleTaskAttributeId;
      this.Name = item.Name;
      this.Value = item.Value;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ScheduleTaskAttributeRateKeys_ScheduleTaskAttribute = Helpers.createClassArray(ScheduleTaskAttributeRateKey, item.ScheduleTaskAttributeRateKeys_ScheduleTaskAttribute);
      this.ScheduleTaskAttributeResourceCalculationKeys_ScheduleTaskAttribute = Helpers.createClassArray(ScheduleTaskAttributeResourceCalculationKey, item.ScheduleTaskAttributeResourceCalculationKeys_ScheduleTaskAttribute);
    }
  }
}